import type { HttpClient } from 'services/api-client/client';
import { returnData } from 'services/api-client/client';
import type { AgentSettingsApi } from '@env0/agent-settings-service/api';

export default (client: HttpClient) => ({
  getValuesFile: (agentKey: string) => {
    return client.get<AgentSettingsApi.GetAgentValues.Response>(`agents/${agentKey}/values`).then(returnData);
  },
  listAgents: (organizationId: string) => {
    const searchParams = new URLSearchParams({ organizationId });
    return client.get<AgentSettingsApi.ListAgents.Response>(`agents?${searchParams.toString()}`).then(returnData);
  },
  getProjectsAssignments: (organizationId: string) => {
    const searchParams = new URLSearchParams({ organizationId });
    return client
      .get<AgentSettingsApi.GetAgentAssignments.Response>(`agents/projects-assignments?${searchParams.toString()}`, {
        hideNotification: true
      })
      .then(returnData);
  },
  setDefaultAgent: (payload: AgentSettingsApi.SetDefaultAgent.Request.Body) => {
    return client.put<AgentSettingsApi.SetDefaultAgent.Response>(`agents/default-agent`, payload).then(returnData);
  },
  assignAgentsToProjects: (organizationId: string, payload: AgentSettingsApi.AssignAgents.Request.Body) => {
    const searchParams = new URLSearchParams({ organizationId });
    return client
      .post<AgentSettingsApi.AssignAgents.Response>(`agents/projects-assignments?${searchParams.toString()}`, payload)
      .then(returnData);
  },
  getDockerAgentDotEnv: (agentKey: string): Promise<string> => {
    return client.get<AgentSettingsApi.GetAgentValues.Response>(`agents/${agentKey}/dotenv`).then(returnData);
  },
  getProjectAgentById: (projectId: string) => {
    return client
      .get<AgentSettingsApi.FindProjectAgentById.Response>(`agents/projects-assignments/${projectId}`)
      .then(returnData);
  },
  createAgent: (payload: AgentSettingsApi.CreateAgent.Request.Body) => {
    return client
      .post<AgentSettingsApi.CreateAgent.Response>('agents', payload, { hideNotification: true })
      .then(returnData);
  },
  updateAgent: (agentKey: string, payload: AgentSettingsApi.UpdateAgent.Request.Body) => {
    return client
      .patch<AgentSettingsApi.UpdateAgent.Response>(`agents/${agentKey}`, payload, { hideNotification: true })
      .then(returnData);
  },
  deleteAgent: (agentKey: string) => {
    return client
      .delete<AgentSettingsApi.DeleteAgent.Response>(`agents/${agentKey}`, { hideNotification: true })
      .then(returnData);
  },
  getAgentSecrets: (agentKey: string) => {
    return client.get<AgentSettingsApi.GetAgentSecrets.Response>(`agents/${agentKey}/secrets`).then(returnData);
  },
  createAgentSecret: (agentKey: string, payload: AgentSettingsApi.CreateAgentSecret.Request.Body) => {
    return client
      .post<AgentSettingsApi.CreateAgentSecret.Response>(`agents/${agentKey}/secrets`, payload, {
        hideNotification: true
      })
      .then(returnData);
  },
  revokeAgentSecret: (agentKey: string, secretId: string) => {
    return client.delete<void>(`agents/${agentKey}/secrets/${secretId}`, { hideNotification: true }).then(returnData);
  }
});
